<template>
  <modal
    width="300px"
    bodyPadding="16px"
    footerPadding="16px"
    @close="onCancel"
  >
    <template #header><div></div></template>
    <div>
      <div class="dialog-title">{{ title }}</div>
      <div class="pt-8" v-html="message"></div>
    </div>
    <template #footer>
      <div class="footer">
        <ui-button
          :text="cancelButtonText"
          :icon="cancelButtonIcon"
          @click="onCancel"
        />

        <ui-button
          :text="confirmButtonText"
          :icon="confirmButtonIcon"
          button-style="red"
          @click="onConfirm"
        />
      </div>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@/composables';

type ConfirmDialogData = {
  title?: string;
  message?: string;
  cancelButtonIcon?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmButtonIcon?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
};

const props = withDefaults(
  defineProps<{
    data?: ConfirmDialogData;
  }>(),
  {
    data: () => ({}),
  },
);

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const title = computed(() => props.data.title || t('Are you sure?'));
const message = computed(
  () => props.data.message || t('The changes will not be saved if you press OK.'),
);
const cancelButtonIcon = computed(() => props.data.cancelButtonIcon || 'fas fa-times');
const cancelButtonText = computed(() => props.data.cancelButtonText || t('Cancel'));
const confirmButtonText = computed(() => props.data.confirmButtonText || t('OK'));
const confirmButtonIcon = computed(() => props.data.confirmButtonIcon || 'fas fa-check');

const onCancel = () => {
  emit('close');
  props.data.onCancel?.();
};

const onConfirm = () => {
  emit('close');
  props.data.onConfirm?.();
};
</script>


<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.dialog-title {
  padding: 0;
  font-size: 18px;
  color: var(--color-graphite);
  font-weight: 700;
}
</style>
